import { Alternative } from './steps/StepMultipleChoice'
import { CivilStatus, StepKey } from './steps/steps'

export enum Transition {
	Next = 'next',
	End = 'end',
}

type Transitions = Record<string, StepKey>

interface State {
	on: Transitions
}

export type QuestionnaireStepKey = Exclude<StepKey, StepKey.End>

interface StateMachine {
	initial: QuestionnaireStepKey
	states: Record<QuestionnaireStepKey, State>
}

export const budgetHelperStateMachine: StateMachine = {
	initial: StepKey.Cohabiting,
	states: {
		[StepKey.Cohabiting]: {
			on: {
				[CivilStatus.Married]: StepKey.MergedFinances,
				[CivilStatus.Alone]: StepKey.ChildrenSelector,
			},
		},
		[StepKey.MergedFinances]: {
			on: {
				[Alternative.YES]: StepKey.SpouseConsent,
				[Alternative.NO]: StepKey.BudgetFlowStart,
			},
		},
		[StepKey.SpouseConsent]: {
			on: {
				[Alternative.YES]: StepKey.ChildrenSelector,
			},
		},
		[StepKey.ChildrenSelector]: {
			on: {
				[Transition.Next]: StepKey.ChildrenAgesSelector,
				[Transition.End]: StepKey.BudgetFlowStart,
			},
		},
		[StepKey.ChildrenAgesSelector]: {
			on: {
				[Transition.Next]: StepKey.BudgetFlowStart,
			},
		},
		[StepKey.BudgetFlowStart]: {
			on: {
				[Transition.Next]: StepKey.End,
			},
		},
	},
}
